module.exports = __webpack_public_path__ + "static/Pras-9f8dfc7ed3fe4c8fceee2a21d33dfc67.jpg";